import { jsx as e, jsxs as s } from "react/jsx-runtime";
import l from "../../components/affiliate-badge.mjs";
import m from "../../components/card-wrapper.mjs";
import { twJoin as n } from "tailwind-merge";
import { useDesignContext as c } from "../../providers/use-design-provider.mjs";
const u = ({
  thankYouPage: { title: t, text: r },
  affiliateLink: a,
  displayAffiliateLink: i
}) => {
  const { isDefaultTheme: o } = c();
  return /* @__PURE__ */ e(m, { children: /* @__PURE__ */ s("div", { className: "relative flex flex-col justify-center gap-5", children: [
    /* @__PURE__ */ e(
      "h1",
      {
        className: n(
          "self-center text-center text-4xl",
          o ? "text-text-primary" : "text-THEME-primary"
        ),
        children: t
      }
    ),
    /* @__PURE__ */ e("p", { className: "whitespace-pre-wrap text-center text-lg", children: r }),
    i && /* @__PURE__ */ e(l, { affiliateLink: a })
  ] }) });
};
export {
  u as ThankYou
};
